import { PayloadAction } from '@reduxjs/toolkit'
import { Draft } from 'immer'
import { ComposerState } from '../state'

export const tiktokReducers = {
  setTiktokPhotoTitle: (state: Draft<ComposerState>, action: PayloadAction<string>) => {
    state.posts.tiktok.title = action.payload
  },
  setTiktokPhotoDescription: (state: Draft<ComposerState>, action: PayloadAction<string>) => {
    state.posts.tiktok.description = action.payload
  }
}
